import {
    Grid
} from '@mui/material';
import {
    makeStyles
} from "@mui/styles";

const useStyles = makeStyles({
    incomingCallPopup: {
        width: "400px",
        position: "absolute",
        zIndex: 1,
        borderRadius: 10,
        top: 80,
        right: "50px",
        border: "1px solid #FFFFFF",
        boxShadow: "0px 0px 4px 3px #0000001A",
        backgroundColor: "white"
    },
    header: {
        display: "flex",
        alignItems: "center",
        borderBottom: "1px solid #D9D9D9",
        padding: "0px 15px"
    },
    ringerIcon: {
        height: "20px"
    },
    headerTitle: {
        marginLeft: "10px",
        fontWeight: "bold",
        fontSize: "14px"
    },
    body: {
        padding: "20px",
        textAlign: "center"
    },
    avatar: {
        height: "80px",
        width: "80px"
    },
    callerName: {
        fontSize: "14px",
        margin: 0,
        fontWeight: "bold",
        color: "#646464",
        marginBottom: "10px"
    },
    callerNumber: {
        fontSize: "14px",
        margin: 0,
        fontWeight: "bold",
        color: "#646464"
    },
    callOptions: {
        margin: "auto",
        marginTop: "20px",
        marginBottom: "20px",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        maxWidth: "230px"
    },
    round: {
        height: "55px",
        width: "55px",
        border: "none",
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer"
    },
    attendCall: {
        backgroundColor: "#008500",
        boxShadow: "0px 0px 12px 0px #00000040"
    },
    attendCallIcon: {
        height: "25px"
    },
    conversationIcon: {
        margin: "0px 10px",
        height: "30px"
    },
    hangupCall: {
        backgroundColor: "#CF3C2A",
        boxShadow: "0px 0px 12px 0px #00000040"
    },
    hangupCallIcon: {
        height: "33px"
    }
});

const IncomingCall = ({
    // session,
    // callAnswered,
    onAnswerCall,
    // toggleMute,
    // toggleHold,
    onHangupCall,
    callerName,
    callerNumber
}) => {
    const classes = useStyles();

    return (
        <Grid className={classes.incomingCallPopup}>
            <Grid
                className={classes.header}
            >
                <img
                    src={require("../../assets/icons/RingerVolume.png")}
                    className={classes.ringerIcon}
                />
                <p className={classes.headerTitle}>Incoming Call....</p>
            </Grid>
            <Grid
                className={classes.body}
            >
                <p className={classes.callerName}>{callerName}</p>
                <img
                    src={require("../../assets/icons/avatar.png")}
                    className={classes.avatar}
                />
                <p className={classes.callerNumber}>{callerNumber}</p>
                <Grid
                    className={classes.callOptions}
                >
                    <button
                        onClick={onAnswerCall}
                        className={[classes.round, classes.attendCall].join(' ')}
                    >
                        <img
                            src={require("../../assets/icons/attendCall.png")}
                            className={classes.attendCallIcon}
                        />
                    </button>
                    <img
                        src={require("../../assets/icons/conversation.png")}
                        className={classes.conversationIcon}
                    />
                    <button
                        onClick={onHangupCall}
                        className={[classes.round, classes.hangupCall].join(' ')}
                    >
                        <img
                            src={require("../../assets/icons/hangupCall.png")}
                            className={classes.hangupCallIcon}
                        />
                    </button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default IncomingCall;